<template>
    <div class="main">
      <div class="container">
          <div class="record-line" v-for="item in lists" :key="item.id">
            <div class="left">
              <div>{{item.target_word}}</div>
              <div class="date">{{ item.createtime }}</div>
            </div>
            <div class="right">
              <span v-text="item.integral > 0 ? '+' + item.integral: item.integral"></span>
            </div>
          </div>
      </div>
    </div>
</template>

<script scoped>
import { getIntegralHistory } from '@/api/snjx'
export default {
  data() {
    return {
      themeId: 1,
      title: '积分记录',
      lists: []
    };
  },
  methods: {
    
  },
  created(){
    getIntegralHistory({theme_id: this.themeId}).then((res) => {
      if (res.code == 1){
        if (res.data) {
          this.lists = res.data
        } else {
          Toast({
            type: 'fail',
            message: '请先注册',
            onClose: () => {
              this.$router.push({ name: 'snjx_register' })
            }
          })
        }
      }else{
        Toast.fail(res.msg)
      }
    })
  }

};
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}

.main {
    min-height: 100vh;
    background: #fcfcfc;
}


.van-tabs {
  min-height: 100vh;
  background: #F5F5F5;
}

.container {
  margin: 20px;
  padding: 30px;
  border-radius: 20px;
  background-color: #FFFFFF;
}

.record-line{ 
  padding: 8px 0; 
  border-bottom: 1px solid #ececec;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .left {
    .date {
      color: #929292;
      font-size: 12px;
      margin-top: 5px;
    }
  }
}
</style>